import {
  IconCalendar,
  IconCalendarExclamation,
  IconBell,
  IconInfoCircle,
  IconClipboardCheck,
  IconPackage,
  IconGift,
} from "@tabler/icons-react";
import { DESIGN_ICONS } from "../../theme/designIcons";

// Map event types to icon and default color
export const notificationIconMap = {
  appointment: {
    icon: IconCalendar,
    defaultColor: "blue",
  },
  "post_appointment_form.submitted": {
    icon: IconClipboardCheck,
    defaultColor: "teal",
  },
  package_purchased: {
    icon: IconPackage,
    defaultColor: "teal",
  },
  gift_card_purchased: {
    icon: IconGift,
    defaultColor: "green",
  },
  gift_card_claimed: {
    icon: IconGift,
    defaultColor: "green",
  },
  // Release notes from the support dashboard.
  "release_note.published": {
    icon: DESIGN_ICONS.Megaphone,
    defaultColor: "teal",
  },
  // Add more event types here as needed
};

// Appointment requests that still need a staff member to accept/decline them
// get a distinct "action required" icon + color so they don't read as an
// already-confirmed ("all set") booking.
export const appointmentRequestIcon = {
  icon: IconCalendarExclamation,
  defaultColor: "orange",
};

// Fallback/default icon for unknown event types
export const defaultNotificationIcon = {
  icon: IconBell,
  defaultColor: "gray",
};

// Helper to get icon and color for a given event type.
// `body` is the notification body; when an appointment notification is flagged
// `requires_action` we surface the action-required icon instead of the plain
// calendar.
export function getNotificationIcon(eventType, body) {
  if (!eventType) return defaultNotificationIcon;
  // Exact-match dotted keys (e.g. post_appointment_form.submitted) before split-bucket.
  if (notificationIconMap[eventType]) return notificationIconMap[eventType];
  const key = eventType.split(".")[0]; // e.g., 'appointment.created' → 'appointment'
  if (key === "appointment" && body?.requires_action) {
    return appointmentRequestIcon;
  }
  return notificationIconMap[key] || defaultNotificationIcon;
}
